<su-headline h="h1" skin="primary">{{ title }}</su-headline>

<su-card [card]="card">
  <div card-content>
    <span>
      Um eine Freistellungsbescheinigung zum Steuerabzug bei Bauleistungen gemäß
      §48b Abs. 1 ESTG einzureichen, halten Sie bitte Ihre Kreditor- und
      Sicherheitsnummer bereit und klicken auf folgenden Link:
    </span>
    <a
      href="https://www.evergabe.telekom.de/bauabzugsteuer"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="E-Vergabe Telekom - Bauabzugssteuer (öffnet in neuem Tab)">
      <span class="arrow-container" aria-hidden="true">
        <scale-icon-action-arrow-right
          fill="#E20074"
          size="30"></scale-icon-action-arrow-right>
        https://www.evergabe.telekom.de/bauabzugsteuer
      </span>
    </a>

    <div class="info-box">
      <div class="info-box__header">
        <scale-icon-alert-information
          aria-label="Information"
          role="img"
          fill="#E20074"></scale-icon-alert-information>
        <span class="info-box__title"
          >Hinweise zum Einreichen der Freistellungsbescheinigung:</span
        >
      </div>
      <ul class="info-box__list">
        <li>Kenntnis Kreditoren-/ und Sicherheitsnummer</li>
        <li>
          Bitte stellen Sie sicher, dass Ihre Freistellungsbescheinigung zum
          Steuerabzug bei Bauleistungen gemäß §48b Abs. 1 ESTG eine ausreichende
          Gültigkeit besitzt und zum Zeitpunkt der Rechnung vorliegt, damit
          diese dann ohne Steuerabzug an Sie gezahlt werden kann
        </li>
      </ul>
    </div>
  </div>
</su-card>
